var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyCpnj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.449,
    height: 16.003,
    viewBox: "0 0 13.449 16.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(-37.286 -8.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5816",
    "data-name": "Grupo 5816",
    transform: "translate(37.286 8.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8485",
    "data-name": "Caminho 8485",
    d: "M37.54,10.356h7.47V26.291H37.286V10.356Zm6.962.508H37.794V25.783H44.5Z",
    transform: "translate(-37.286 -10.287)",
    fill: "#38d2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8486",
    "data-name": "Caminho 8486",
    d: "M204,92.017l5.724,3.378.125.074v8.882h-5.978v-.508h5.47V95.757l-5.6-3.3Z",
    transform: "translate(-196.406 -88.347)",
    fill: "#38d2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8487",
    "data-name": "Caminho 8487",
    d: "M71.914,54.631h1.515V56.4H71.66V54.631Zm1.007.508h-.753v.753h.753Z",
    transform: "translate(-70.144 -52.61)",
    fill: "#38d2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8488",
    "data-name": "Caminho 8488",
    d: "M138.19,54.631h1.515V56.4h-1.769V54.631Zm1.007.508h-.753v.753h.753Z",
    transform: "translate(-133.497 -52.61)",
    fill: "#38d2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8489",
    "data-name": "Caminho 8489",
    d: "M71.914,132.182h1.515v1.769H71.66v-1.769Zm1.007.508h-.753v.753h.753Z",
    transform: "translate(-70.144 -126.741)",
    fill: "#38d2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8490",
    "data-name": "Caminho 8490",
    d: "M138.19,132.182h1.515v1.769h-1.769v-1.769Zm1.007.508h-.753v.753h.753Z",
    transform: "translate(-133.497 -126.741)",
    fill: "#38d2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8491",
    "data-name": "Caminho 8491",
    d: "M71.914,209.733h1.515V211.5H71.66v-1.769Zm1.007.508h-.753v.753h.753Z",
    transform: "translate(-70.144 -200.872)",
    fill: "#38d2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8492",
    "data-name": "Caminho 8492",
    d: "M138.19,209.733h1.515V211.5h-1.769v-1.769Zm1.007.508h-.753v.753h.753Z",
    transform: "translate(-133.497 -200.872)",
    fill: "#38d2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8493",
    "data-name": "Caminho 8493",
    d: "M71.914,287.284h1.515v1.769H71.66v-1.769Zm1.007.508h-.753v.753h.753Z",
    transform: "translate(-70.144 -275.003)",
    fill: "#38d2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8494",
    "data-name": "Caminho 8494",
    d: "M138.19,287.284h1.515v1.769h-1.769v-1.769Zm1.007.508h-.753v.753h.753Z",
    transform: "translate(-133.497 -275.003)",
    fill: "#38d2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8495",
    "data-name": "Caminho 8495",
    d: "M238.3,279.722H241v4.055h-2.958v-4.055Zm2.2.508H238.55v3.039h1.941Z",
    transform: "translate(-229.188 -267.774)",
    fill: "#38d2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8496",
    "data-name": "Caminho 8496",
    d: "M251.767,197.083h1.515v1.769h-1.769v-1.769Zm1.007.508h-.753v.753h.753Z",
    transform: "translate(-242.065 -188.78)",
    fill: "#38d2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8497",
    "data-name": "Caminho 8497",
    d: "M242.036,55.57V52.541h2.746V57h-.508V53.049h-1.729V55.57Z",
    transform: "translate(-233.006 -50.612)",
    fill: "#38d2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8498",
    "data-name": "Caminho 8498",
    d: "M267.4,8.8h.508v2.183H267.4Z",
    transform: "translate(-257.256 -8.8)",
    fill: "#38d2d9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyCpnj);
export default __webpack_public_path__ + "static/media/keyCpnj.840b319634a6eb46bcf71837586f3d3b.svg";
export { ForwardRef as ReactComponent };